<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <GrocerTabLinks />

                    <GrocerUpsertForm
                        class="mt-4"
                        :entity="entity"
                        @success="$router.push(`/grocers/${$route.params.id}`)"
                        @deleted="$router.push('/grocers')"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js'

    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks'
    import GrocerUpsertForm from '@/components/grocers/GrocerUpsertForm'

    export default {
        components: {
            GrocerTabLinks,
            GrocerUpsertForm,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch()
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id

                const [error, result] = await to(this.axios.get(`/grocers/${id}`))
                this.entity = result.data

                if (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            }
        }
    }
</script>
